import { ContentWrap, useIntersectionObserver } from '@/ui';
import { useRef } from 'react';
import { ISiteSectionEntry } from '@move-frontend/contentful';
import CvgLogo from '../../../assets/cvg-logo.svg';
import Navigation from '../navigation/Navigation';
import { PageRoutes } from '../../../features/app/pages/domain/constants/PageRoutes';
import {
	Container,
	ScrollingWrapper,
	StickyWrapper,
	StyledLogoLink,
} from './Topbar.styles';

interface IProps {
	onBackgroundScheme?: 'light' | 'dark';
	fullScreenIFrame?: boolean;
	siteSection?: ISiteSectionEntry;
}

export function Topbar({
	fullScreenIFrame,
	onBackgroundScheme = 'light',
	siteSection,
}: IProps) {
	const ref = useRef<HTMLDivElement>(null);
	const intersect = useIntersectionObserver(ref, {
		threshold: 1,
	});
	const isSticky = intersect?.isIntersecting === false;

	return (
		<Container ref={ref} fullScreenIFrame={fullScreenIFrame}>
			{/* Scroll with page */}
			<ScrollingWrapper>
				<ContentWrap>
					<StyledLogoLink
						tabIndex={0}
						href={PageRoutes.Home}
						invertLogo={onBackgroundScheme === 'dark'}
						aria-label="Go to homepage"
					>
						<CvgLogo />
					</StyledLogoLink>
				</ContentWrap>
			</ScrollingWrapper>

			{/* Fixed on top */}
			<StickyWrapper isSticky={isSticky}>
				<ContentWrap style={{ position: 'relative' }}>
					<Navigation
						type={onBackgroundScheme === 'light' ? 'primary' : 'secondary'}
						isSticky={isSticky}
						siteSection={siteSection}
					/>
				</ContentWrap>
			</StickyWrapper>
		</Container>
	);
}
